define('BookingEngine/app-general/main',['../../app-Loader/main', '../../app/ui/dialog', 'util'], function (loader, dialog, util) {
    return {
        run: function () {
            var container = $(".bookingEngine");

            if (container.length <= 0) {
                return;
            }

            // Update Progress bar
            if ($(window).width() < 768) {
                if ($('.checkoutModule , #oceanCruiseModule').length) {
                    $('.breadcrumb .yourHoliday').addClass('current');
                    $('.breadcrumbMobile span').html('01');
                }

                if ($('#passdetails').length) {
                    $('.breadcrumb .passengerDetails').addClass('current');
                    $('.breadcrumbMobile span').html('02');
                }

                if ($('#reviewpay , .PCI-compare').length) {
                    $('.breadcrumb .payment').addClass('current');
                    $('.breadcrumbMobile span').html('03');
                }

                if ($('#confirm').length) {
                    $('.breadcrumb .done').addClass('current');
                    $('.breadcrumbMobile span').html('04');
                }
            } else {
                if ($('.checkoutModule , #oceanCruiseModule').length) {
                    $('.breadcrumb .yourHoliday').addClass('current');
                }

                if ($('#passdetails').length) {
                    $('.breadcrumb .yourHoliday , .breadcrumb .passengerDetails').addClass('current');
                }

                if ($('#reviewpay , .PCI-compare').length) {
                    $('.breadcrumb .yourHoliday , .breadcrumb .passengerDetails , .breadcrumb .payment').addClass('current');
                }

                if ($('#confirm').length) {
                    $('.breadcrumb .yourHoliday , .breadcrumb .passengerDetails , .breadcrumb .payment , .breadcrumb .done').addClass('current');
                }
            };

            //Move Phone number.
			//Only display contact number in header, not the request a call 
            if ($('.openingTimesContainer.header h3[data-contact-details]').length > 0)
                $('.openingTimesContainer.header ').appendTo('.phoneNumberHolder').show();

            if ($('body').hasClass('cruise-product')) {
                var headerHeight = $("#header").outerHeight();
                $('#navSpacer').css({ 'height': headerHeight + 'px' });
            }

            //  Product image slideshow.
            function galleryHeight() {
                var maxHeight = 0;

                $('#gallery img').each(function () {
                    maxHeight = Math.max($(this).outerHeight(), maxHeight);
                });

                $('#gallery').css('height', maxHeight + 'px');
            }

            galleryHeight();
            $('#gallery img').css('position', 'absolute');
            $("#gallery > img").slice(1).hide();

            if ($('#gallery').find('img').length > 1) {
                setInterval(function () {
                    $('#gallery > img')
                        .first()
                        .fadeOut(1000)
                        .next()
                        .fadeIn(1000)
                        .end()
                        .appendTo('#gallery');
                }, 5000);
            }

            // show basket
            $('body').on('click', '.basketPopUp', function () {
                var height = $(window).height();
                $('#BEBasket:hidden').addClass('fixedBasket').find('>div').css('max-height', height - 40);
            });

            $('body').on('click', '.closeBasket', function () {
                $('#BEBasket').removeClass('fixedBasket').find('>div').css('max-height', 'auto');
            });

            $(window).on("resize", function () {
                galleryHeight();

                if ($('#BEBasket.fixedBasket').length && $(window).width() > 768) {
                    $('#BEBasket').removeClass('fixedBasket').find('>div').css('max-height', 'auto');
                }
            });

            $(document).ready(function() {
                util.initialisePopovers();
            });

            /* Opening Times pop up leftNav*/

            $('.cruiseExpert h3').on("click", function (e) {
                e.preventDefault();
                if ($(window).width() < 992) {
                    if ($('.cruiseExpert h3').hasClass('active')) {
                        $('.cruiseExpert .openingTimesContainer').hide();
                    }
                    else {
                        $('.cruiseExpert .openingTimesContainer').show();
                    }
                    $('.cruiseExpert h3').toggleClass('active')

                };
            });

            /* Opening Times pop up*/
            $('.viewOpeningTimes').hover(function () {
                $('.leftNavBox #openingTimes').show();
            }, function () {
                $('.leftNavBox #openingTimes').hide();
            });

            /* Whats Included overlay*/
            $('.fullList').on("click", function (e) {
                e.preventDefault();

                var contentDiv = $('<div/>');

                if ($('.bookingWhatsIncluded').hasClass('ocean')) {
                    contentDiv.append($('.bookingWhatsIncludedModal:hidden .includedMenu h4').clone());

                }
                else if ($('.bookingWhatsIncluded').hasClass('river')) {
                    contentDiv.append($('.bookingWhatsIncludedModal:hidden').html());

                }

                dialog.show('Our Price Includes', contentDiv, null, null, null, null, 'modal-cruise included', {
                    modal: true,
                    draggable: false,
                    resizable: false
                });
            });
            if ($('.bookingWhatsIncluded').hasClass('ocean')) {
                $('.bookingWhatsIncludedModal:hidden .includedMenu h4').clone().insertAfter('.bookingWhatsIncluded h3');
                $('.bookingWhatsIncluded h4').slice(3).remove();
            }
            else if ($('.bookingWhatsIncluded').hasClass('river')) {
                $('.bookingWhatsIncludedModal:hidden').clone().insertAfter('.bookingWhatsIncluded h3');
                $('.bookingWhatsIncluded .bookingWhatsIncludedModal').children().slice(3).remove();
            }


            window.loadedModules("BookingEngine/app-general");
        }
    }
});
